import { Box, Divider, Menu, MenuItem } from "@mui/material";
import { MprcMenuItemCheck } from "components/MprcMenuItemCheck";
import * as React from "react";
import { MprcDropDownItemAny } from "./MprcIconButtonDropdown";
import { MprcLink } from "./MprcLink";


////////////////////////////////////////////////////////////////////////////////

interface IProps {
    text: string;
    items: MprcDropDownItemAny[];
    title?: string;
    checkSelectedItem?: boolean;
    selectedItem?: any;
    disabled?: boolean;
    separator?: "blank" | "dash";
    onChange: (selectedValue: any) => void;
}

export const MprcLinkDropdown: React.FC<IProps> = (props) => {
    const { items, separator = "blank", title, text, checkSelectedItem, disabled, onChange } = props;

    const [anchor, setAnchor] = React.useState<Element | null>(null);

    const menuItems = React.useMemo(() => {
        var arr: React.ReactNode[] = [];
        items.forEach((v, index) => {
            if (checkSelectedItem)
                arr.push(
                    <MprcMenuItemCheck
                        key={index}
                        item={v}
                        selectedItem={props.selectedItem}
                        onClick={() => {
                            onChange(v.value ?? "?");
                            setAnchor(null);
                        }}
                    />
                );
            else
                arr.push(
                    <MenuItem
                        key={index}
                        onClick={() => {
                            onChange(v.value ?? "?");
                            setAnchor(null);
                        }}
                        disabled={v.disabled}
                        sx={{ paddingTop: 0, paddingBottom: 0 }}
                    >
                        {v.text}
                    </MenuItem>
                );
            if (v.appendSeparator) {
                if (separator === "dash") arr.push(<Divider key={`${index}_divider`} />);
                if (separator === "blank") arr.push(<Box sx={{ mt: 1.5 }} key={`${index}_divider`} />);
            }
        });
        return arr;
    }, [items]);

    return (
        <>
            <MprcLink
                title={title}
                color="inherit"
                fontSize="inherit"
                onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => setAnchor(e.currentTarget)}
                disabled={disabled}
            >
                {text}
            </MprcLink>

            <Menu anchorEl={anchor} open={anchor != null} onClose={() => setAnchor(null)}>
                {menuItems}
            </Menu>
        </>
    );
};
